import { isAnnualPeriod } from "@nf/common";
import { useTranslation } from "next-i18next";

import Button from "components/Button";
import { useIsAuthenticated } from "hooks";
import type { SimpleOfferCardProps } from "../SimpleOfferCard";

import styles from "./ChooseOfferButton.module.scss";

const ChooseOfferButton = ({ offer }: SimpleOfferCardProps) => {
  const { isRegisteredViaCampaign } = useIsAuthenticated();
  const { t } = useTranslation("translations");

  return (
    <div className={styles.container}>
      <Button size="medium" variant="primary" className={styles.button}>
        {t("web_choose_subscription")}
      </Button>

      <span className={styles.description}>
        {isAnnualPeriod(offer.Period)
          ? t(
              isRegisteredViaCampaign
                ? "web_choose_subscription_annual_aeldresagen_usp"
                : "web_choose_subscription_annual_usp"
            )
          : t("web_landing_page__features__price_desc")}
      </span>
    </div>
  );
};

export default ChooseOfferButton;
